var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-snackbar",
    {
      attrs: {
        color: _vm.color,
        top: "",
        timeout: _vm.timeout,
        role: "alert",
        "aria-live": "polite",
        "aria-atomic": true,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "action",
            fn: function ({ attrs }) {
              return [
                _vm._t("action"),
                _c(
                  "v-btn",
                  _vm._b(
                    {
                      staticClass: "float-right ma-1",
                      attrs: {
                        icon: "",
                        small: "",
                        "aria-label": "Fechar notificação",
                      },
                      on: {
                        click: function ($event) {
                          _vm.hidden = false
                        },
                      },
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  [
                    _c("v-icon", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("mdi-close"),
                    ]),
                  ],
                  1
                ),
              ]
            },
          },
        ],
        null,
        true
      ),
      model: {
        value: _vm.hidden,
        callback: function ($$v) {
          _vm.hidden = $$v
        },
        expression: "hidden",
      },
    },
    [
      _c("span", { staticClass: "sr-only" }, [
        _vm._v(_vm._s(_vm.statusPrefix)),
      ]),
      _vm.message && _vm.message != ""
        ? _c("span", [_vm._v(_vm._s(_vm.message))])
        : _c(
            "ul",
            { attrs: { "aria-label": "Lista de erros" } },
            _vm._l(_vm.errors, function (error, i) {
              return _c("li", { key: i }, [
                _vm._v(
                  " " +
                    _vm._s(
                      error.toString().replace('[ "', "").replace('" ]', "")
                    ) +
                    " "
                ),
              ])
            }),
            0
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }